module.exports = {
	"_format": "hh-sol-artifact-1",
	"contractName": "MainChef",
	"sourceName": "contracts/levels/MainChef.sol",
	"abi": [
		{
			"inputs": [
				{
					"internalType": "contract KhinkalToken",
					"name": "_khinkal",
					"type": "address"
				},
				{
					"internalType": "address",
					"name": "_devaddr",
					"type": "address"
				},
				{
					"internalType": "uint256",
					"name": "_khinkalPerBlock",
					"type": "uint256"
				},
				{
					"internalType": "uint256",
					"name": "_startBlock",
					"type": "uint256"
				},
				{
					"internalType": "uint256",
					"name": "_bonusEndBlock",
					"type": "uint256"
				},
				{
					"internalType": "address",
					"name": "_governance",
					"type": "address"
				}
			],
			"stateMutability": "nonpayable",
			"type": "constructor"
		},
		{
			"anonymous": false,
			"inputs": [
				{
					"indexed": true,
					"internalType": "address",
					"name": "user",
					"type": "address"
				},
				{
					"indexed": true,
					"internalType": "uint256",
					"name": "pid",
					"type": "uint256"
				},
				{
					"indexed": false,
					"internalType": "uint256",
					"name": "amount",
					"type": "uint256"
				}
			],
			"name": "Deposit",
			"type": "event"
		},
		{
			"anonymous": false,
			"inputs": [
				{
					"indexed": true,
					"internalType": "address",
					"name": "user",
					"type": "address"
				},
				{
					"indexed": true,
					"internalType": "uint256",
					"name": "pid",
					"type": "uint256"
				},
				{
					"indexed": false,
					"internalType": "uint256",
					"name": "amount",
					"type": "uint256"
				}
			],
			"name": "EmergencyWithdraw",
			"type": "event"
		},
		{
			"anonymous": false,
			"inputs": [
				{
					"indexed": true,
					"internalType": "address",
					"name": "previousOwner",
					"type": "address"
				},
				{
					"indexed": true,
					"internalType": "address",
					"name": "newOwner",
					"type": "address"
				}
			],
			"name": "OwnershipTransferred",
			"type": "event"
		},
		{
			"anonymous": false,
			"inputs": [
				{
					"indexed": true,
					"internalType": "address",
					"name": "user",
					"type": "address"
				},
				{
					"indexed": true,
					"internalType": "uint256",
					"name": "pid",
					"type": "uint256"
				},
				{
					"indexed": false,
					"internalType": "uint256",
					"name": "amount",
					"type": "uint256"
				}
			],
			"name": "Withdraw",
			"type": "event"
		},
		{
			"inputs": [],
			"name": "BONUS_MULTIPLIER",
			"outputs": [
				{
					"internalType": "uint256",
					"name": "",
					"type": "uint256"
				}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [
				{
					"internalType": "uint256",
					"name": "_allocPoint",
					"type": "uint256"
				},
				{
					"internalType": "contract IERC20",
					"name": "_lpToken",
					"type": "address"
				},
				{
					"internalType": "bool",
					"name": "_withUpdate",
					"type": "bool"
				}
			],
			"name": "add",
			"outputs": [],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [
				{
					"internalType": "contract IERC20",
					"name": "_lpToken",
					"type": "address"
				}
			],
			"name": "addToken",
			"outputs": [],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [],
			"name": "bonusEndBlock",
			"outputs": [
				{
					"internalType": "uint256",
					"name": "",
					"type": "uint256"
				}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [
				{
					"internalType": "uint256",
					"name": "_pid",
					"type": "uint256"
				},
				{
					"internalType": "uint256",
					"name": "_amount",
					"type": "uint256"
				}
			],
			"name": "deposit",
			"outputs": [],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [
				{
					"internalType": "address",
					"name": "_devaddr",
					"type": "address"
				}
			],
			"name": "dev",
			"outputs": [],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [],
			"name": "devaddr",
			"outputs": [
				{
					"internalType": "address",
					"name": "",
					"type": "address"
				}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [
				{
					"internalType": "uint256",
					"name": "_pid",
					"type": "uint256"
				}
			],
			"name": "emergencyWithdraw",
			"outputs": [],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [
				{
					"internalType": "uint256",
					"name": "_from",
					"type": "uint256"
				},
				{
					"internalType": "uint256",
					"name": "_to",
					"type": "uint256"
				}
			],
			"name": "getMultiplier",
			"outputs": [
				{
					"internalType": "uint256",
					"name": "",
					"type": "uint256"
				}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [],
			"name": "governance",
			"outputs": [
				{
					"internalType": "address",
					"name": "",
					"type": "address"
				}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [],
			"name": "khinkal",
			"outputs": [
				{
					"internalType": "contract KhinkalToken",
					"name": "",
					"type": "address"
				}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [],
			"name": "khinkalPerBlock",
			"outputs": [
				{
					"internalType": "uint256",
					"name": "",
					"type": "uint256"
				}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [],
			"name": "massUpdatePools",
			"outputs": [],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [],
			"name": "owner",
			"outputs": [
				{
					"internalType": "address",
					"name": "",
					"type": "address"
				}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [
				{
					"internalType": "uint256",
					"name": "_pid",
					"type": "uint256"
				},
				{
					"internalType": "address",
					"name": "_user",
					"type": "address"
				}
			],
			"name": "pendingKhinkal",
			"outputs": [
				{
					"internalType": "uint256",
					"name": "",
					"type": "uint256"
				}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [
				{
					"internalType": "uint256",
					"name": "",
					"type": "uint256"
				}
			],
			"name": "poolInfo",
			"outputs": [
				{
					"internalType": "contract IERC20",
					"name": "lpToken",
					"type": "address"
				},
				{
					"internalType": "uint256",
					"name": "allocPoint",
					"type": "uint256"
				},
				{
					"internalType": "uint256",
					"name": "lastRewardBlock",
					"type": "uint256"
				},
				{
					"internalType": "uint256",
					"name": "accKhinkalPerShare",
					"type": "uint256"
				},
				{
					"internalType": "uint256",
					"name": "lastKhinkalReward",
					"type": "uint256"
				}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [],
			"name": "poolLength",
			"outputs": [
				{
					"internalType": "uint256",
					"name": "",
					"type": "uint256"
				}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [],
			"name": "renounceOwnership",
			"outputs": [],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [
				{
					"internalType": "uint256",
					"name": "_pid",
					"type": "uint256"
				},
				{
					"internalType": "uint256",
					"name": "_allocPoint",
					"type": "uint256"
				},
				{
					"internalType": "bool",
					"name": "_withUpdate",
					"type": "bool"
				}
			],
			"name": "set",
			"outputs": [],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [
				{
					"internalType": "address",
					"name": "_governance",
					"type": "address"
				}
			],
			"name": "setGovernance",
			"outputs": [],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [],
			"name": "startBlock",
			"outputs": [
				{
					"internalType": "uint256",
					"name": "",
					"type": "uint256"
				}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [],
			"name": "totalAllocPoint",
			"outputs": [
				{
					"internalType": "uint256",
					"name": "",
					"type": "uint256"
				}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [
				{
					"internalType": "address",
					"name": "newOwner",
					"type": "address"
				}
			],
			"name": "transferOwnership",
			"outputs": [],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [
				{
					"internalType": "uint256",
					"name": "_pid",
					"type": "uint256"
				}
			],
			"name": "updatePool",
			"outputs": [],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [
				{
					"internalType": "uint256",
					"name": "",
					"type": "uint256"
				},
				{
					"internalType": "address",
					"name": "",
					"type": "address"
				}
			],
			"name": "userInfo",
			"outputs": [
				{
					"internalType": "uint256",
					"name": "amount",
					"type": "uint256"
				},
				{
					"internalType": "uint256",
					"name": "rewardDebt",
					"type": "uint256"
				}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [
				{
					"internalType": "uint256",
					"name": "_pid",
					"type": "uint256"
				}
			],
			"name": "withdraw",
			"outputs": [],
			"stateMutability": "nonpayable",
			"type": "function"
		}
	],
	"bytecode": "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",
	"deployedBytecode": "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",
	"linkReferences": {},
	"deployedLinkReferences": {}
};


//////////////////
// WEBPACK FOOTER
// ./build/contracts/levels/MainChef.sol/MainChef.json
// module id = 1579
// module chunks = 0